import React, {FC, ReactElement, useEffect, useState} from 'react';
import styled from 'styled-components';
import { environment } from '../../../environments/environment';

interface separatorProps {
    height: string;
    anchorName: string;
    anchorTrigger: string;
    editorPlugins: Record<string, any>
};

interface separatorElementProps {
    height: string;
};

const SeparatorWrapper = styled.div`
position: relative;
    .resize-controls {
        button:not(.height) {
            display: none;
        }
    }
`;

const SeparatorElement = styled.div<separatorElementProps>`
&.separator {
    height: ${props => props.height + 'px' || '10px'};
}
`;

const Separator: FC<separatorProps> = ({...props}): ReactElement => {
    const [ height, setHeight ] = useState<number>(Number(props.height));
    const emitHeight = (height: number): void => setHeight(height);
    const ResizeAxis = props.editorPlugins?.ResizeAxis;
    useEffect(() => setHeight(Number(props.height)), [ props.height ]);
    
    return (
        <SeparatorWrapper>
            {
                ResizeAxis && <ResizeAxis
                    heightProps={{ height, property: 'height', min: 5, max: 350, containerHeight: Number(props.height), emitHeight }}
                    widthProps={{ width: '100', property: "", min: 0, max: 0, elementDomWidth: 0, containerWidth: 0, emitWidth: () => { } }}
                />
            }
            <SeparatorElement className={"separator"} height={String(height)}></SeparatorElement>
        </SeparatorWrapper>
    )
}

const environmentLink: string = environment().assetsLink;
export const settings: any = [
        [//group
            {
                settingName: 'Size',
                isMainSettings: true,
                controls: [
                    {
                        controlName: 'Slider',
                        title: 'Size',
                        property: 'height',
                        defaultValue: 70,
                        suffix: 'px',
                        min: 5,
                        max: 350
                    }
                ],
            }
        ],
        [
            {
                settingName: 'Anchor',
            }
        ]
    ];

export default {
    Separator,
    settings,
    label: 'Spacer'
};



